import { useCallback, useEffect, useState } from 'react';

type UseCollapsibleReturnData<T> = [T[], () => void, boolean];

interface UseCollapsibleListOptions<T> {
  list: T[];
  maxVisible: number;
  disabled: boolean;
  callback?: (expanded: boolean) => void;
}

export function useCollapsibleList<T = object>({
  list,
  maxVisible,
  disabled,
  callback,
}: UseCollapsibleListOptions<T>): UseCollapsibleReturnData<T> {
  const [expanded, setExpanded] = useState(disabled);

  useEffect(() => {
    setExpanded(disabled);
  }, [disabled]);

  const toggle = useCallback(() => {
    setExpanded(disabled || !expanded);
    callback?.(!expanded);
  }, [expanded]);

  return [expanded ? list : list.slice(0, maxVisible), toggle, expanded];
}
